module.exports = __webpack_public_path__ + "static/media/b-icon.4eb81fb9.png";